import React from 'react';

// Small inline icons for the redesigned Task Board (currentColor only).

export const PinIcon = () => (
    <svg width="11" height="11" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true" focusable="false">
        <path fillRule="evenodd" d="M5.05 4.05a7 7 0 119.9 9.9L10 18.9l-4.95-4.95a7 7 0 010-9.9zM10 11a2 2 0 100-4 2 2 0 000 4z" clipRule="evenodd" />
    </svg>
);

export const DealerIcon = () => (
    <svg width="16" height="16" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true" focusable="false">
        <path fillRule="evenodd" d="M4 4a2 2 0 012-2h8a2 2 0 012 2v14a1 1 0 01-1 1h-2a1 1 0 01-1-1v-2a1 1 0 00-1-1h-2a1 1 0 00-1 1v2a1 1 0 01-1 1H5a1 1 0 01-1-1V4zm3 1h2v2H7V5zm2 4H7v2h2V9zm2-4h2v2h-2V5zm2 4h-2v2h2V9z" clipRule="evenodd" />
    </svg>
);

export const SearchIcon = () => (
    <svg width="15" height="15" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true" focusable="false">
        <path fillRule="evenodd" d="M8 4a4 4 0 100 8 4 4 0 000-8zM2 8a6 6 0 1110.89 3.476l4.817 4.817a1 1 0 01-1.414 1.414l-4.816-4.816A6 6 0 012 8z" clipRule="evenodd" />
    </svg>
);

export const CaretIcon = () => (
    <svg width="10" height="10" viewBox="0 0 12 12" fill="currentColor" aria-hidden="true" focusable="false">
        <path d="M6 8L1 3h10z" />
    </svg>
);

// Status glyphs in the column heads (N-24): ring, half, check, slash.
const GLYPH_PATHS = {
    open: <circle cx="8" cy="8" r="5.5" fill="none" stroke="currentColor" strokeWidth="1.6" />,
    progress: (
        <>
            <circle cx="8" cy="8" r="5.5" fill="none" stroke="currentColor" strokeWidth="1.6" />
            <path d="M8 2.5a5.5 5.5 0 010 11z" fill="currentColor" />
        </>
    ),
    done: (
        <>
            <circle cx="8" cy="8" r="6.5" fill="currentColor" />
            <path d="M5 8.2l2 2 4-4.2" fill="none" stroke="var(--v2-surface)" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
        </>
    ),
    cancelled: (
        <>
            <circle cx="8" cy="8" r="5.5" fill="none" stroke="currentColor" strokeWidth="1.6" />
            <path d="M4.2 11.8l7.6-7.6" stroke="currentColor" strokeWidth="1.6" />
        </>
    ),
    branch: <path d="M8 1.5a4.5 4.5 0 014.5 4.5c0 3.4-4.5 8.5-4.5 8.5S3.5 9.4 3.5 6A4.5 4.5 0 018 1.5zm0 3a1.5 1.5 0 100 3 1.5 1.5 0 000-3z" fill="currentColor" />,
};

export const StatusGlyph = ({ tone }) => (
    // eslint-disable-next-line react/prop-types
    GLYPH_PATHS[tone] ? <svg width="15" height="15" viewBox="0 0 16 16" aria-hidden="true" focusable="false">{GLYPH_PATHS[tone]}</svg> : null
);
